export const ROOT = '/ConfigurationOfApproversAPI';
export const LIST = `${ROOT}/getcoabypage`;
export const MODULES_DDL = `${ROOT}/getmodulesddl`;
export const APPROVERS_DDL = `${ROOT}/getapproversddl`;
export const ISAPPROVERCHECK = `${ROOT}/isapprovercheck`;
export const EMPLOYEESV = `${ROOT}/getemployeesaboveSVddl`;